const firebaseConfig = {
  apiKey: "AIzaSyDW8xEvXf-aYehNwBxNQX-wfnLgCRs3baU",
  authDomain: "health-care-service-for-all.firebaseapp.com",
  projectId: "health-care-service-for-all",
  storageBucket: "health-care-service-for-all.appspot.com",
  messagingSenderId: "209404229659",
  appId: "1:209404229659:web:986ff5d2c3ec839fbd20be"
};

export default firebaseConfig;
